import { cn } from '@/lib/cn';
import { formatKwacha } from '@/lib/money';

interface MoneyTextProps {
  ngwee: number;
  rightAligned?: boolean;
  /** Keep zero at full strength (default is muted, so a screen of K0.00 stays quiet). */
  strongZero?: boolean;
  className?: string;
}

/** A money figure: tabular digits, negatives red with a minus sign, zero muted. */
export const MoneyText = ({ ngwee, rightAligned = false, strongZero = false, className }: MoneyTextProps) => (
  <span
    className={cn(
      'tabular-nums',
      rightAligned && 'text-right',
      ngwee < 0 && 'text-bad',
      ngwee === 0 && !strongZero && 'text-muted',
      className
    )}
  >
    {formatKwacha(ngwee)}
  </span>
);

export const Money = MoneyText;
